module.exports = __webpack_public_path__ + "img/portfolio-06.5dee8713.ab7cb995.jpg";